import { UiMessageComponent } from '@common/ui/frontend-shared/message';
import { DynamicPipe, InnerHtmlClickHandlerDirective } from '@core/frontend-shared/utils';
import { StaticInstruction } from './shared/static.instruction';
import * as i0 from "@angular/core";
const _c0 = () => ({
  stayOnPage: true
});
function StaticFieldComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-message", 2);
    i0.ɵɵelement(1, "div", 3);
    i0.ɵɵpipe(2, "dynamicPipe");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.classes);
    i0.ɵɵproperty("type", ctx_r0.showMessage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(2, 4, ctx_r0.text, ctx_r0.pipes), i0.ɵɵsanitizeHtml);
  }
}
function StaticFieldComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
    i0.ɵɵpipe(1, "dynamicPipe");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.classes);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 4, ctx_r0.text, ctx_r0.pipes), i0.ɵɵsanitizeHtml)("innerHtmlClickHandler", i0.ɵɵpureFunction0(7, _c0));
  }
}
export let StaticFieldComponent = /*#__PURE__*/(() => {
  class StaticFieldComponent {
    static {
      this.ɵfac = function StaticFieldComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StaticFieldComponent)();
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: StaticFieldComponent,
        selectors: [["ng-component"]],
        inputs: {
          value: "value",
          text: "text",
          classes: "classes",
          showMessage: "showMessage"
        },
        decls: 2,
        vars: 2,
        consts: [[3, "type", "class"], [3, "class", "innerHTML", "innerHtmlClickHandler"], [3, "type"], [3, "innerHTML"], [3, "innerHTML", "innerHtmlClickHandler"]],
        template: function StaticFieldComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, StaticFieldComponent_Conditional_0_Template, 3, 7, "ui-message", 0);
            i0.ɵɵconditionalCreate(1, StaticFieldComponent_Conditional_1_Template, 2, 8, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.showMessage ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.showMessage ? 1 : -1);
          }
        },
        dependencies: [UiMessageComponent, InnerHtmlClickHandlerDirective, DynamicPipe],
        encapsulation: 2
      });
    }
  }
  return StaticFieldComponent;
})();
export class StaticTextInstruction extends StaticInstruction {
  constructor(config) {
    super();
    /** object map of input name -> source name / function */
    this.inputMap = {
      pipes: 'pipes',
      text: 'text',
      showMessage: 'showMessage',
      classes: 'classes'
    };
    this.attributeMap = {};
    this.isInput = false;
    this.useFieldWrapper = true;
    this.setConfig(config);
  }
  load() {
    return Promise.resolve(StaticFieldComponent);
  }
}